module.exports = __webpack_public_path__ + "media/images/top/introduction/introduction_banner_sp-75c1f0f3287f050f653665e988ee076f.png";